export const formatPhoneNumber = (value: string, isBackspace: boolean = false) => {
  const cleanValue = value.replace(/\D+/g, '');

  if (isBackspace && value.endsWith('-')) {
    return value.slice(0, -1);
  }

  if (cleanValue.length <= 2) {
    return `(${cleanValue}`;
  } else if (cleanValue.length <= 6) {
    return `(${cleanValue.substring(0, 2)}) ${cleanValue.substring(2)}`;
  } else if (cleanValue.length <= 10) {
    return `(${cleanValue.substring(0, 2)}) ${cleanValue.substring(2, 7)}-${cleanValue.substring(7)}`;
  }

  return `(${cleanValue.substring(0, 2)}) ${cleanValue.substring(2, 7)}-${cleanValue.substring(7, 11)}`;
};
